import * as AppConstants from 'app/AppConstants';
import keyBy from 'lodash/keyBy';

const initialState = () => ({
  stacks: {},
  stacksStateById: {},
  collections: {},
  collectionsByStackId: {},
  accessDeniedStacks: {},
  accessRequests: new Set(),
  powerUpAssignments: {},
});

export const STATES = {
  FAILED: 'FAILED',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
};

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.STACK__LOAD_BY_ID_STARTED: {
      return {
        ...state,
        stacksStateById: {
          [action.payload.id]: STATES.LOADING,
        },
      };
    }

    case AppConstants.STACK__LOAD_BY_ID_ACCESS_DENIED: {
      const {id, errorInfo} = action.payload;
      return {
        ...state,
        stacksStateById: {
          [id]: STATES.FAILED,
        },
        accessDeniedStacks: {
          [id]: errorInfo,
        },
      };
    }

    case AppConstants.STACK__LOAD_BY_ID_FAILED: {
      return {
        ...state,
        stacksStateById: {
          [action.payload.id]: STATES.FAILED,
        },
      };
    }

    case AppConstants.STACK__LOAD_BY_ID_FINISHED: {
      const stack = action.payload.stack;
      const sortedCollections = stack.collections.map((collection, index) => ({
        ...collection,
        sortIndex: index,
      }));
      const collectionsById = keyBy(sortedCollections, 'id');
      return {
        ...state,
        stacksStateById: {
          [stack.id]: STATES.LOADED,
        },
        stacks: {
          ...state.stacks,
          [stack.id]: stack,
        },
        collections: {
          ...state.collections,
          ...collectionsById,
        },
        collectionsByStackId: {
          ...state.collectionsByStackId,
          [stack.id]: new Set(Object.keys(collectionsById)),
        },
      };
    }

    case AppConstants.STACK__ACCESS_REQUESTED: {
      const {stackId} = action.payload;

      return {
        ...state,
        accessRequests: new Set(state.accessRequests).add(stackId),
      };
    }

    case AppConstants.STACK__POWER_UP_ASSIGNED: {
      const {stackId, userId} = action.payload;

      return {
        ...state,
        powerUpAssignments: {
          ...state.powerUpAssignments,
          [stackId]: userId,
        },
      };
    }
    default:
      return state;
  }
};
